import React from "react";
import useWorkspaceAuth from "@/components/teams/useWorkspaceAuth";
import useSubscribeToEventUpdates from "@/components/hooks/useSubscribeToEventUpdates";
import { roomCopyOf } from "@/components/rooms/roomCopies";
import EventSettingsScreenContainer from "@/components/EventSettingsScreenContainer";

const EventSubScreen = ({
  route,
  backButtonLite,
  contentComponent: ContentComponent,
}) => {
  const params = route?.params || {};
  const slug =
    params.slug || params.event?.slug || params.relatedEvent?.slug || null;
  // The account the event is in: yours, or the one you're working in (Teams).
  const { broadcaster } = useWorkspaceAuth();

  const passedEvent = params.event && params.event.slug;
  const relatedEvent = params.relatedEvent;
  // After switching rooms in place (How to Go Live on phones), the room's
  // copy from the chips stands in until it has loaded.
  const initialEvent = passedEvent
    ? params.event
    : slug
    ? roomCopyOf(slug) || { broadcaster, slug }
    : null;

  const { event, loading, error } = useSubscribeToEventUpdates(
    initialEvent,
    Boolean(initialEvent?.slug)
  ); //!passedEvent

  return (
    <EventSettingsScreenContainer
      backButtonLite={backButtonLite}
      loading={loading}
      useOwnScrollLayout={Boolean(ContentComponent?.useOwnScrollLayout)}
      hideHeader={Boolean(ContentComponent?.hideSubScreenHeader)}
    >
      <ContentComponent
        event={event}
        relatedEvent={relatedEvent}
        loading={loading}
        route={route}
      />
    </EventSettingsScreenContainer>
  );
};

export default EventSubScreen;
